export const generateCategoryRoute = (title, subTitle) => {
  let route = `/category/${encodeURIComponent(title)}`;
  if (subTitle) route += `/${encodeURIComponent(subTitle)}`;

  return route;
};

export { default as getClassName } from './get-class-name';
export { default as getTrainerName } from './get-trainer-name';
export { isMobile } from './responsive';
